const i18nService = {
  defaultLanguage: 'ua',

  languages: [
    {
      lang: 'en',
      name: 'English',
      flag: process.env.BASE_URL + 'media/svg/flags/united-states.svg',
    },
    {
      lang: 'ka',
      name: 'Georgian',
      flag: process.env.BASE_URL + 'media/svg/flags/georgia.svg',
    },
    {
      lang: 'ua',
      name: 'Ukrainian',
      flag: process.env.BASE_URL + 'media/svg/flags/ukraine.svg',
    },
  ],

  /**
   * Keep the active language in the localStorage
   * @param lang
   */
  setActiveLanguage (lang) {
    localStorage.setItem('language', lang);
  },

  /**
   * Get the current active language
   * @returns {string | string}
   */
  getActiveLanguage () {
    return localStorage.getItem('language') || this.defaultLanguage;
  },
};

export default i18nService;
